import { useSearchParamsContext } from '@internal/blocks/SearchResultsBlock/SearchParamsContext'
import { TDisplayDefinitionEntryNumber } from '@internal/utils/displayDefinition/entry/DisplayDefinitionEntryNumber'
import { RangeInput } from '@renderer-ui-library/molecules'
import {
  SearchFilterCategory,
  trackRangeFilterChange,
} from '@renderer-ui-library/organisms'
import { RangeSelectValue } from 'blocks/SearchCoverBlock/RangeSelectFilter'
import { TRangeFilterValues } from 'blocks/SearchResultsBlock/TRangeFilterValues'
import { useRangeFilterOptions } from 'blocks/SearchResultsBlock/useRangeFilterOptions'
import { useSearchResultsRouting } from 'blocks/SearchResultsBlock/useSearchResultsRouting'
import React, { useCallback } from 'react'

type Props = {
  config: TDisplayDefinitionEntryNumber
}

export const RangeFilter: React.FC<Props> = React.memo((props) => {
  const { searchParams } = useSearchParamsContext()
  const { gotoSearchResults } = useSearchResultsRouting()
  const filter: TRangeFilterValues | undefined =
    searchParams.rangeFilters[props.config.machineAttribute]

  const rangeFilterOptions = useRangeFilterOptions(
    props.config.machineAttribute,
    props.config.label
  )

  const handleRangeChange = useCallback(
    (value: { min?: RangeSelectValue; max?: RangeSelectValue }) => {
      gotoSearchResults({
        ...searchParams,
        rangeFilters: {
          ...searchParams.rangeFilters,
          [props.config.machineAttribute]: {
            ...filter,
            ...value,
          },
        },
        amount: undefined,
      })

      trackRangeFilterChange(props.config.machineAttribute, value)
    },
    [gotoSearchResults, searchParams, props.config, filter]
  )

  return (
    <SearchFilterCategory title={rangeFilterOptions.label}>
      <RangeInput
        {...rangeFilterOptions}
        minValue={filter?.min}
        maxValue={filter?.max}
        step={1}
        onChange={handleRangeChange}
      />
    </SearchFilterCategory>
  )
})

RangeFilter.displayName = 'RangeFilter'
